import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "./motion";
import { StoreBadge } from "./ui";
import { PhoneMockup } from "./PhoneMockup";

const POINTS = [
  "Search inter-city routes in seconds",
  "Instant booking & secure in-app payments",
  "Real-time chat with your driver",
  "Trip tracking you can share with family",
];

export const AppShowcase = () => {
  return (
    <section id="app" className="relative overflow-hidden bg-white py-24 lg:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2 lg:px-12">
        <div className="order-2 lg:order-1">
          <motion.div animate={{ y: [0, -18, 0] }} transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}>
            <PhoneMockup />
          </motion.div>
        </div>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="mb-6 inline-flex items-center gap-3 font-display text-xs font-semibold uppercase tracking-[0.22em] text-[#2340b5]">
              <span className="h-px w-10 bg-[#2340b5]" /> The SafeRide App
            </p>
            <h2 className="font-display text-4xl font-extrabold leading-none tracking-tighter text-[#12142b] sm:text-5xl lg:text-6xl">
              Your whole trip,<br /> in your pocket.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#565b73]">
              This page is just the start. Download the SafeRide app to search routes, book seats and travel with verified drivers across Canada.
            </p>
          </Reveal>

          <ul className="mt-10 space-y-4">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={i * 0.08} className="flex items-center gap-4" as="li">
                <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-[#2340b5]">
                  <Check className="h-4 w-4 text-white" strokeWidth={3} />
                </span>
                <span className="text-base text-[#12142b]">{p}</span>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.3} className="mt-10 flex flex-wrap gap-4">
            <StoreBadge store="apple" testId="app-appstore-btn" />
            <StoreBadge store="google" testId="app-googleplay-btn" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
